/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetProposalJobRow } from '../openapi-types.gen.js';
import { type useGetProposalJobArgs, useGetProposalJobSpec } from '../specs/ai.spec.gen.js';

export type { GetProposalJobRow } from '../openapi-types.gen.js';
export type { useGetProposalJobArgs } from '../specs/ai.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): jobId.
 */
export const useGetProposalJob = createHook(useGetProposalJobSpec);


/**
 * Hover/intent prefetch companion for `useGetProposalJob`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetProposalJob();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetProposalJob = createPrefetchHook(useGetProposalJobSpec);
